import { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';

export function useChatMessages(subdomain) {
  const { t } = useTranslation();
  const [messages, setMessages] = useState([]);
  const [isTyping, setIsTyping] = useState(false);

  useEffect(() => {
    if (subdomain) {
      const welcomeMessage = {
        id: Date.now(),
        text: t('chatWindow.welcomeMessage'),
        sender: 'bot',
        timestamp: new Date().toISOString(),
      };
      setMessages([welcomeMessage]);
      setIsTyping(false);
    }
  }, [subdomain, t]);

  const addUserMessage = (text) => {
    const userMessage = {
      id: Date.now(),
      text,
      sender: 'user',
      timestamp: new Date().toISOString(),
    };
    setMessages((prev) => [...prev, userMessage]);
    return userMessage.id;
  };

  const addBotMessage = (text) => {
    const botMessage = {
      id: Date.now() + 1,
      text,
      sender: 'bot',
      timestamp: new Date().toISOString(),
    };
    setMessages((prev) => [...prev, botMessage]);
    return botMessage.id;
  };

  const addStreamingMessage = () => {
    const assistantMessageId = Date.now() + 1;
    const assistantMessage = {
      id: assistantMessageId,
      text: '',
      sender: 'bot',
      timestamp: new Date().toISOString(),
      isStreaming: true,
    };
    setMessages((prev) => [...prev, assistantMessage]);
    return assistantMessageId;
  };

  const updateStreamingMessage = (messageId, text, isComplete = false) => {
    setMessages((prev) => {
      return prev.map((msg) =>
        msg.id === messageId ? { ...msg, text, isStreaming: !isComplete } : msg
      );
    });
  };

  const addErrorMessage = (text) => {
    const errorMessage = {
      id: Date.now() + 1,
      text,
      sender: 'bot',
      timestamp: new Date().toISOString(),
    };
    setMessages((prev) => [...prev, errorMessage]);
  };

  return {
    messages,
    isTyping,
    setIsTyping,
    addUserMessage,
    addBotMessage,
    addStreamingMessage,
    updateStreamingMessage,
    addErrorMessage,
  };
}
